enum ClientAction {
    Install = 0,
    UnInstall = 1,
}

export default ClientAction;
